import { Injectable, Signal, signal } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AsideService {
  private _open = signal<boolean>(false);

  constructor(private router: Router) { }

  get isOpen(): Signal<boolean> { return this._open; }

  toggle = (): void => this._open.set(!this._open());

  close = (): void => this._open.set(false);
}
